import angular from 'angular';
import {} from 'angularjs-toaster/toaster.min.css';
import { flatten, forIn, identity, mapValues, pickBy, values } from 'lodash';

module.exports = angular.module('common.services.resource', [
  require('./resource-inheritable'),
  require('angularjs-toaster'),
])
.factory('odResource', function($resourceInheritable, toaster) {
  return function() {
    var resource = $resourceInheritable.apply(this, arguments);
    var toastMap = pickBy(mapValues(arguments[2], 'toast'), identity);

    // On error, put the server response onto the model as `$errors`.
    forIn(resource, function(action, name) {
      if (name !== 'bind') {
        var toasts = toastMap[name];
        resource[name] = function() {
          toasts && toasts.wait && (toaster.clear(), toaster.wait(toasts.wait));
          var result = action.apply(this, arguments);
          result.$actionName = name;

          var promise = result.$promise || result;
          var model = result.$promise ? result : this;
          promise.then(function success(response) {
            var message = null;
            if (response.message) {
              if (typeof response.message == 'object') {

                message = response.message.join(",\n");
              } else {
                message = response.message;
              }
            }
            toasts && toasts.success && (toaster.clear(), toaster.success(toasts.success, message)); // eslint-disable-line max-len
          }, function error(response) {
            model.$errors = response.data;
            var errors = flatten(values(response.data));
            toasts && toasts.error && (toaster.clear(), toaster.error(toasts.error, errors.join(",\n"))); // eslint-disable-line max-len
          });

          return result;
        };
      }
    });

    return resource;
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/services/resource.js
 **/